/** @format */

import {Navigate, Route, Routes, useLocation} from 'react-router-dom';

import {ROUTES} from 'constants/ROUTES';

import MainLayoutNew from 'layouts/MainLayoutNew';

import PrivateRoute from 'components/PrivateRoute';

import WideLayout from 'layouts/WideLayout';

import BadWords from './BadWords';
import BudgetScoreDescription from './BudgetScoreDescription';

import CategoryNew from './CategoryNew';
import Congratulation from './Congratulation';
import CorrectWords from './CorrectWords';
import Details from './Details';
import ErrorDescription from './ErrorDescription';
import GeoGroups from './GeoGroups';
import Graphs from './Graphs';

import {ErrorSettings} from './ErrorSettings';
import Project from './Project';
import ProjectReports from './ProjectReports';
import Regions from './Regions';
import Report from './Report';
import {Reports} from './Reports';
import ScoreDescription from './ScoreDescription';
import StopWords from './StopWords';
import Wait from './Wait';
import WaitForPayment from './WaitForPayment';

const wideLayoutContent = [ROUTES.MAIN_STATUS, ROUTES.MAIN_PROJECT];

const Main = () => {
  const location = useLocation();

  // https://reactrouter.com/web/example/modal-gallery
  const background = location.state && location.state.background;
  const isWideContainer = wideLayoutContent.find(route => location.pathname.includes(route));

  const Component = isWideContainer ? WideLayout : MainLayoutNew;

  return (
    <Component isWideContainer={isWideContainer}>
      <Routes location={background || location}>
        <Route
          path={ROUTES.MAIN_WAIT}
          element={
            <PrivateRoute>
              <Wait />
            </PrivateRoute>
          }
        />
        <Route
          path={`${ROUTES.MAIN_STATUS}/*`}
          element={
            <PrivateRoute>
              <Project />
            </PrivateRoute>
          }
        />
        <Route
          path={`${ROUTES.MAIN_PROJECT}/*`}
          element={
            <PrivateRoute>
              <Project />
            </PrivateRoute>
          }
        />
        <Route
          path={`${ROUTES.PROJECT_REPORTS}/*`}
          element={
            <PrivateRoute>
              <ProjectReports />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTES.MAIN_CATEGORY}
          element={
            <PrivateRoute>
              <CategoryNew />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTES.MAIN_DETAILS}
          element={
            <PrivateRoute>
              <Details />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTES.MAIN_CONGRATULATION}
          element={
            <PrivateRoute>
              <Congratulation />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTES.MAIN_GRAPHS}
          element={
            <PrivateRoute>
              <Graphs />
            </PrivateRoute>
          }
        />
        <Route
          index
          element={
            <PrivateRoute>
              <Navigate to={`${ROUTES.MAIN_STATUS}`} />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTES.MAIN_WAIT_FOR_PAYMENT}
          element={
            <PrivateRoute>
              <WaitForPayment />{' '}
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTES.MAIN_ERROR_SETTINGS}
          element={
            <PrivateRoute>
              <ErrorSettings />{' '}
            </PrivateRoute>
          }
        />
        <Route
          path={`${ROUTES.MAIN_REPORTS}`}
          element={
            <PrivateRoute>
              <Reports />
            </PrivateRoute>
          }
        />
      </Routes>

      {background && (
        <Routes>
          <Route
            path={ROUTES.MAIN_ERROR_DESCRIPTION}
            element={
              <PrivateRoute>
                <ErrorDescription />
              </PrivateRoute>
            }
          />
          <Route
            path={ROUTES.MAIN_REGIONS}
            element={
              <PrivateRoute>
                <Regions />
              </PrivateRoute>
            }
          />
          <Route
            path={ROUTES.MAIN_BAD_WORDS}
            element={
              <PrivateRoute>
                <BadWords />
              </PrivateRoute>
            }
          />
          <Route
            path={ROUTES.MAIN_CORRECT_WORDS}
            element={
              <PrivateRoute>
                <CorrectWords />
              </PrivateRoute>
            }
          />
          <Route
            path={ROUTES.MAIN_GEO_GROUPS}
            element={
              <PrivateRoute>
                <GeoGroups />
              </PrivateRoute>
            }
          />
          <Route
            path={ROUTES.MAIN_STOP_WORDS}
            element={
              <PrivateRoute>
                <StopWords />
              </PrivateRoute>
            }
          />
          <Route
            path={ROUTES.MAIN_SCORE_DESCRIPTION}
            element={
              <PrivateRoute>
                <ScoreDescription />
              </PrivateRoute>
            }
          />
          <Route
            path={ROUTES.MAIN_BUDGET_SCORE_DESCRIPTION}
            element={
              <PrivateRoute>
                <BudgetScoreDescription />
              </PrivateRoute>
            }
          />
          <Route
            path={`${ROUTES.MAIN_REPORT}/*`}
            element={
              <PrivateRoute>
                <Report />
              </PrivateRoute>
            }
          />
        </Routes>
      )}
    </Component>
  );
};

export default Main;
